<template>
	<div class="row">
		<div class="col-xs-12 col-md-10 col-md-offset-1" id="payment-container">
			<!-- CREDIT CARD FORM STARTS HERE -->
			<div class="panel panel-default credit-card-box">
				<div class="panel-heading display-table">
					<div class="row display-tr">
						<h3 class="panel-title display-td">Payment Details</h3>
						<div class="display-td">
							<img
									loading="lazy"
									class="img-responsive pull-right"
									src="../../public/images/accepted_cards_visa_mastercard.webp"
							/>
						</div>
					</div>
				</div>
				<div class="panel-body">
					<form role="form" id="payment-form" method="POST" action="javascript:void(0);">
						<div class="row">
							<div class="col-xs-12">
								<div class="form-group">
									<label for="cardNumber">CARD NUMBER</label>
									<div class="input-group">
										<div class="form-control" :class="validations.CardNumber" id="cardNumber"></div>
										<span class="input-group-addon"><i class="fa fa-credit-card" :class="validations.icon"></i></span>
									</div>
								</div>
							</div>
						</div>
						<div class="row">
							<div class="col-xs-7 col-md-7">
								<div class="form-group">
									<label for="cardExpiry"
									><span class="hidden-xs">EXPIRATION</span><span class="visible-xs-inline">EXP</span> DATE</label
									>
									<div class="form-control" :class="validations.CardExpiration" id="cardExpiry"></div>
								</div>
							</div>
							<div class="col-xs-5 col-md-5 pull-right">
								<div class="form-group">
									<label for="cardCVC">CVV CODE</label>
									<div class="form-control" :class="validations.Cvv" id="cardCVC"></div>
								</div>
							</div>
						</div>
						<div class="row">
							<div class="col-xs-12">
								<button
										@click="submitModal"
										class=""
										:disabled="shouldDisablePayBtn || isProcessing"
										type="button"
										v-html="payButtonText"
								></button>
							</div>
						</div>
						<div class="row">
							<div class="col-xs-12">
								<p v-if="validations.paymentError" class="payment-errors">{{ validations.paymentError }}</p>
							</div>
						</div>
					</form>
				</div>
			</div>
			<!-- CREDIT CARD FORM ENDS HERE -->
		</div>
	</div>
</template>

<script>
import paysafeService from "@/service/paysafe"

export default {
	props: {
		user: {
			required: true
		},
		orderId: {
			required: false,
			default: null
		},
		isImmediatePayment: {
			required: false,
			default: false
		}
	},
	data: () => ({
		paymentResponseMessage: "",
		paymentResponse: {},
		validations: {
			CardNumber: "",
			Cvv: "",
			CardExpiration: "",
			icon: "",
			paymentError: null
		},
		isProcessing: false,
		payButtonText: "Update",
		paySafeInstance: null,
		isCardDataValid: false,
		cardBrand: ""
	}),

	mounted() {
		const apiKey = paysafeService.getApiKey()

		const options = {
			// select the Paysafe test / sandbox environment
			environment: paysafeService.getApiEnv(),
			// set the CSS selectors to identify the payment field divs above
			// set the placeholder text to display in these fields
			fields: {
				cardNumber: {
					selector: "#cardNumber",
					placeholder: "Card Number"
				},
				expiryDate: {
					selector: "#cardExpiry",
					placeholder: "MM / YY"
				},
				cvv: {
					selector: "#cardCVC",
					placeholder: "CVV"
				}
			}
		}

		// Init proper submit button label
		this.resetSubmitText()

		// initalize the hosted iframes using the SDK setup function
		paysafe.fields.setup(apiKey, options, (instance, error) => {
			this.paySafeInstance = instance
			if (error) {
				console.log(error)
			} else {
				instance
						.fields("cvv cardNumber expiryDate")
						.valid((eventInstance, event) => this.validateCC(eventInstance, event))
				instance
						.fields("cvv cardNumber expiryDate")
						.invalid((eventInstance, event) => this.validateCC(eventInstance, event))

				instance.fields.cardNumber.on("FieldValueChange", (instance, event) => {
					if (!instance.fields.cardNumber.isEmpty() && instance.getCardBrand()) {
						const cardBrand = instance.getCardBrand().replace(/\s+/g, "")
						this.showCCBrand(cardBrand)
					}
				})
			}
		})
	},
	computed: {
		isUserDataValid() {
			return (
					this.user.billing_firstname !== "" &&
					this.user.billing_lastname !== "" &&
					this.user.address !== "" &&
					this.user.country !== "" &&
					this.user.city !== "" &&
					this.user.zip !== ""
			)
		},
		shouldDisablePayBtn() {
			return !this.isCardDataValid || !this.isUserDataValid
		}
	},
	methods: {
		validateCC(eventInstance, event) {
			let className = "success"
			if (event.type !== "Valid") {
				className = "error"
			}

			this.validations[event.target.fieldName] = className
			this.isCardDataValid = eventInstance.areAllFieldsValid()
		},
		showCCBrand(cardBrand) {
			switch (cardBrand) {
				case "AmericanExpress":
					this.validations.icon = "fa-cc-amex"
					break
				case "MasterCard":
					this.validations.icon = "fa-cc-mastercard"
					break
				case "Visa":
					this.validations.icon = "fa-cc-visa"
					break
				case "DinersClub":
					this.validations.icon = "fa-cc-diners-club"
					break
				case "JCB":
					this.validations.icon = "fab fa-cc-jcb"
					break
				case "Discover":
					this.validations.icon = "fa-cc-discover"
					break
				case "Maestro":
					this.validations.icon = "fa-cc-discover"
					break
			}

			this.cardBrand = cardBrand.toString()
		},
		submitModal() {
			if (this.cardBrand !== "MasterCard" && this.cardBrand !== "Visa") {
				this.validations.paymentError = "Only MasterCard or Visa are allowed."
				return
			}

			if (this.shouldDisablePayBtn) {
				this.$emit("validate-fields")
				return
			}
			
			// Prevent multiple payments from double clicking
			this.isProcessing = true;

			this.paySafeInstance.tokenize(
					{
						vault: {
							holderName: this.user.billing_firstname + " " + this.user.billing_lastname,
							billingAddress: {
								country: this.user.country,
								zip: this.user.zip,
								state: this.user.state,
								city: this.user.city,
								street: this.user.address,
								street2: this.user.address2
							}
						}
					},
					(instance, error, result) => {
						if (error) {
							this.payButtonText = "Try Again"
							this.isProcessing = false
							/* Show Paysafe errors on the form */
							this.validations.paymentError = error.detailedMessage
						} else {
							/* Hide Paysafe errors on the form */
							this.validations.paymentError = null
							/* Visual feedback */
							this.payButtonText =
									(this.isImmediatePayment ? "Paying..." : "Updating") + ' <i class="fa fa-spinner fa-pulse"></i>'
							// response contains token
							this.$emit("payment-token", result.token)
						}
					}
			)
		},
		resetSubmitText() {
			this.payButtonText = this.isImmediatePayment ? "Pay Now" : "Update"
		}
	}
}
</script>

<style scoped src="bootstrap/dist/css/bootstrap.min.css"></style>
<style scoped>
@import "https://maxcdn.bootstrapcdn.com/font-awesome/4.3.0/css/font-awesome.min.css";

button,
.button {
	font-size: 2em;
	color: #fff;
	font-family: Oswald, Impact, sans-serif;
	background: var(--theme-color-primary);
	cursor: pointer;
	border: 0px solid #fff;
	display: inline-block;
	line-height: normal;
	width: 100%;
}

.button.small {
	padding: 3px 10px 5px;
	margin: 10px 0px;
}

.credit-card-box .panel-title {
	display: inline;
	font-weight: bold;
}

.credit-card-box .form-control.error {
	border-color: red;
	outline: 0;
	box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 8px rgba(255, 0, 0, 0.6);
}

.credit-card-box label.error {
	font-weight: bold;
	color: red;
	padding: 2px 8px;
	margin-top: 2px;
}

.credit-card-box .payment-errors {
	font-weight: bold;
	color: red;
	padding: 2px 8px;
	margin-top: 12px;
}

.credit-card-box label {
	display: block;
}

.credit-card-box .display-tr {
	display: table-row;
}

.credit-card-box .display-td {
	display: table-cell;
	vertical-align: middle;
	width: 50%;
}

.credit-card-box .panel-heading img {
	min-width: 180px;
	border-style: solid;
	border-width: 3px;
	border-color: white;
	box-shadow: 3px 3px 5px #d3d3d3;
}

.form-control {
	height: 50px;
}
</style>